import React from "react";
import { Layout } from "antd";
import MinimalHeaderComponent from "../../reusables/MinimalHeader/MinimalHeaderComponent";


function HeaderContainer(){
  return (
        <Layout id='header'>
          <MinimalHeaderComponent transferenceHref="https://www.autofact.cl/transferencias" showLink={true} />
        </Layout>
  );
}

export default HeaderContainer;

